"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppLoadingAnimation = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const StyledContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.Color.Feedback.InfoLight};
  border-radius: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Border.Radius.Small)}`};
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
  height: 100%;
`;
const StyledLoadingMessage = styled_components_1.default.div `
  position: relative;
  text-align: center;
  width: 90%;
  min-height: ${ui_common_components_1.utils.rem(100)};
`;
const StyledSpinnerWrapper = styled_components_1.default.div `
  display: flex;
  height: 264px;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
function AppLoadingAnimation({ loadingMessage = [], loadingVideo, isLoading, crop, objectFit, }) {
    const [currentMessageIndex, setCurrentMessageIndex] = (0, react_1.useState)(0);
    const theme = (0, styled_components_1.useTheme)();
    (0, react_1.useEffect)(() => {
        if (!isLoading || loadingMessage.length === 0)
            return;
        const interval = setInterval(() => {
            if (currentMessageIndex === loadingMessage.length - 1)
                return;
            setCurrentMessageIndex((prevIndex) => prevIndex + 1);
        }, 2000);
        return () => clearInterval(interval);
    }, [isLoading, loadingMessage.length, currentMessageIndex]);
    return ((0, jsx_runtime_1.jsx)(StyledContainer, { children: loadingVideo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.VideoPlayer, { src: loadingVideo, autoPlay: true, controls: false, loop: true, muted: true, crop: crop, objectFit: objectFit }), (0, jsx_runtime_1.jsx)(StyledLoadingMessage, { children: loadingMessage.length > 0 &&
                        loadingMessage.map((message, index) => ((0, jsx_runtime_1.jsx)(ui_common_components_1.Transition, { visible: index === currentMessageIndex, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: "BodyLarge", children: message }) }, index))) })] })) : ((0, jsx_runtime_1.jsxs)(StyledSpinnerWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.LoadingSpinner, { variant: 'dots' }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Text, { size: 'Body', color: theme.Color.Brand.Primary, children: "Loading" })] })) }));
}
exports.AppLoadingAnimation = AppLoadingAnimation;
//# sourceMappingURL=AppLoadingAnimation.js.map